const SET_MENU_DISPLAY_MODE = Object.freeze({
    SIMPLIFIED: 'simplified',
    DETAILED: 'detailed'
});

const CURRENCY_SYMBOL_POSITION = Object.freeze({
    BEFORE: 'before',
    AFTER: 'after'
});

const DEFAULT_QUANTITY_SETMENU = 1;

const DECIMAL_PRECISION = 2;

const DEFAULT_BOOLEAN_VALUES = Object.freeze({
    TRUE: 'true',
    FALSE: 'false'
});

module.exports = {
    SET_MENU_DISPLAY_MODE,
    CURRENCY_SYMBOL_POSITION,
    DEFAULT_QUANTITY_SETMENU,
    DECIMAL_PRECISION,
    DEFAULT_BOOLEAN_VALUES
}; 